<template lang="pug">
  v-container(fluid px-6 py-4)
    v-row(no-gutters)
      app-page-header(v-if="showHeader" @search="search" :searchValue="searchValue" :showUser="showUser") {{ title }}
      app-appear-animation
        .col-12
          slot
    app-dialog-loading(v-model="loading")
    app-fab(v-if="isFabVisible" :items="allFabItems")
</template>

<script>
export default {
  name: "app-page",
  props: {
    title: String,
    searchValue: {
      type: String,
      default: ""
    },
    loading: Boolean,
    fabItems: Array,
    fabWithoutDefaults: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showUser: {
      type: Boolean,
      default: true
    },
    showFab: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    document.title = this.title || "Универсальная платформа для судов и участников судопроизводства";
  },

  computed: {
    // fabWithoutDefaults - установлен в true, чтобы скрыть нереализованые на данный момент пункты "Сообщение" и "Заметку"
    allFabItems() {
      let items = this.fabItems || [];
      return this.fabWithoutDefaults
        ? items
        : [...this.fabDefaultItems, { divider: true }, ...items];
    },

    fabDefaultItems() {
      return [
        {
          icon: "assignment",
          title: "Сообщение",
          action: () => this.$root.$emit("dev")
        },
        {
          icon: "book",
          title: "Заметку",
          action: () => this.$root.$emit("dev")
        }
      ];
    },

    isFabVisible() {
      return this.showFab && this.allFabItems.length > 0;
    }
  },

  methods: {
    search(text) {
      this.$emit("search", text);
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
